import styled from 'styled-components'

export const SidebarWrapper = styled.div`
  height: 100vh;
  .ant-menu-item.ant-menu-item-selected {
    color: #5bd4c1;
    border-right: 2px solid #5bd4c1;
    background: rgba(91, 212, 193, 0.1);
  }

  .ant-menu-light .ant-menu-submenu-selected > .ant-menu-submenu-title {
    color: #5bd4c1;
  }

  .ant-menu-item {
    border-radius: 0;
    margin: 0;
    width: 100%;
  }

  .active-link {
    color: #5bd4c1;
    /* background: rgba(91, 212, 193, 0.1); */
  }

  .inactive-link {
    color: inherit !important;
  }
`

export const NavbarWrapper = styled.div`
  background-color: #fff;
  .admin {
    display: flex;
    padding: 10px 24px;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
  }

  .text-header {
    display: flex;
    align-items: center;
    gap: 16px;
    color: #48d3d3;
    padding: 10px 24px;
    font-family: 'Roboto';
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    border-top: 1px solid #e6ebf1;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  }

  .sub-title {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #5bd4c1;
  }

  .sub-title::before {
    content: '';
    display: inline-block;
    height: 4px;
    width: 4px;
    border-radius: 4px;
    background-color: #5bd4c1;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 10px;
  }
`
